import { type FC, useMemo } from 'react';
import { TPO_METRIC_BREADCRUMB } from '../../../config/testIds';
import { useTpoGenConfig } from '../../../context/CustomerConfigContext';
import type { KpiViewType, MetricType } from '../types';

interface KpiViewMetricBreadcrumbProps {
    kpiViewType: KpiViewType;
    metricType: MetricType;
}

const KpiViewMetricBreadcrumb: FC<KpiViewMetricBreadcrumbProps> = ({ kpiViewType, metricType }) => {
    const { metricPageConfig } = useTpoGenConfig();
    const kpiViewLabels = useMemo(
        () => new Map(metricPageConfig.kpiViewTypeOptions.map((opt) => [opt.value, opt.label])),
        [metricPageConfig],
    );
    const metricLabels = useMemo(
        () => new Map(metricPageConfig.metricTypeOptions.map((opt) => [opt.value, opt.label])),
        [metricPageConfig],
    );
    const showMetric = kpiViewType === 'actuals_vs_pre_snapshot';
    const kpiLabel = kpiViewLabels.get(kpiViewType) ?? kpiViewType;
    const metricLabel = metricLabels.get(metricType) ?? metricType;

    return (
        <div
            className="flex flex-row items-center gap-x-6 text-xs text-[#52525C] py-2"
            data-testid={TPO_METRIC_BREADCRUMB}
        >
            <span data-testid={`${TPO_METRIC_BREADCRUMB}_kpi_view`} data-state-value={kpiViewType}>
                <span className="font-medium">{'KPI View: '}</span>
                <span>{kpiLabel}</span>
            </span>
            {showMetric ? (
                <span data-testid={`${TPO_METRIC_BREADCRUMB}_metric_type`} data-state-value={metricType}>
                    <span className="font-medium">{'Metrics: '}</span>
                    <span>{metricLabel}</span>
                </span>
            ) : null}
        </div>
    );
};

KpiViewMetricBreadcrumb.displayName = 'KpiViewMetricBreadcrumb';
export default KpiViewMetricBreadcrumb;
